import { section2Data } from "../../../data/about";
import classes from "./Section2.module.css";

export default function Section2() {
  return (
    <section className={classes.section}>
      <div className="container">
        <header className={classes.header}>
          <span className={classes.eyebrow}>Why MITSI</span>

          <h2 className={classes.title}>
            Why Choose <span className={classes.highlight}>MITSI?</span>
          </h2>

          <p className={classes.description}>
            Our approach is based on evidence, allowing for compassionate care.
            We blend innovation with patient-focused practices.
          </p>
        </header>

        <div className={classes.cards}>
          {section2Data.map(({ icon: Icon, title, description }) => (
            <article className={classes.card} key={title}>
              <span className={classes.icon} aria-hidden="true">
                <Icon />
              </span>

              <div className={classes.cardContent}>
                <h3 className={classes.cardTitle}>{title}</h3>

                <p className={classes.cardDescription}>{description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
